import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Error404 from '../components/Error404'
const ErrorPage = () => {
  return (
    <Wrapper className="page-100">
    <section>
      <Error404/>
      <Link to="/" className="btn">Back Home </Link>
    </section>
    </Wrapper>
  )
}

const Wrapper = styled.main`
  background: var(--clr-primary-10);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  h1 {
    font-size: 10rem;
  }
  h3 {
    text-transform: none;
    margin-bottom: 2rem;
  }

  .btn{
    margin-top: 1.2rem;
  }
`

export default ErrorPage
